import React, { useEffect } from "react";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { Link, Redirect } from "react-router-dom";
import { Base64 } from "js-base64";
import {
  getGeoInfo,
  getCustomerLogin,
  LoginConfirmation,
  LoginAgentConfirmation,
} from "./axios";
import "./Agent.css";
import Spinner from 'react-bootstrap/Spinner';

class AgentLogin extends React.Component {
 
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
    
      country: "",
      country_code: "",
      currency: "",
      ip_address: "",
      //customerEmail: cookies.get("userDetails") || "",
      customerEmailForData: localStorage.getItem("userDetails") || "abc",
      customerDetails: {},
      profileNew: false,
      profileNewAgain: false,
      LoginEmail: "",
      LoginPassword: "",
      errorPassword: false,
      notActivePassword: false,
      notVerified: false,
      redirect: null,
      btnloader: false
    };
  }
  
  componentDidMount() {
 
    let userData = localStorage.getItem("userDetails");
    getGeoInfo().then(
      (data) => {
        // console.log(data);
        this.setState({ country: data.country_name });
        this.setState({ country_code: data.country_calling_code });
        this.setState({ currency: data.currency });
        this.setState({ ip_address: data.ip });
      },
      (error) => {}
    );

    if (userData != null) {
      const { cookies } = this.props;

      let newData = JSON.parse(userData);
      getCustomerLogin(newData.email).then(
        (data) => {
          //   console.log(data);
          this.setState({ customerDetails: data });

          let Verified = "";
          if (data.verified == 1) {
            Verified = true;
          }

          const dataSearch = {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            country_code: data.country_code,
            verified: Verified,
            uid: data.id,
          };

          let JsonData = JSON.stringify(dataSearch);

          localStorage.setItem("userDetails", JsonData);
         
        },
        (error) => {}
      );
    }

  }
  ChangeLoginEmail = (event) => {
    this.setState({ LoginEmail: event.target.value });
  };

  ChangeLoginPassword = (event) => {
    this.setState({ LoginPassword: event.target.value });
  };

  LoginConfirm = (e) => {
    e.preventDefault();
    this.setState({ btnloader: true });
    this.setState({ errorPassword: false });
    this.setState({ notActivePassword: false });
    this.setState({ notVerified: false });
    let emailNew = this.state.LoginEmail;
    let email = '';
    if (emailNew.length > 0) {
        email = emailNew;
    } else {
      email = "";
      //  email = this.state.customerEmail.email;
    }
    let password = this.state.LoginPassword;

    LoginAgentConfirmation(email, password).then(
        (data) => {
         
          //  console.log(data);
           //if(data.typedata == 'agent'){
            if (data == 'not_correct') {
                this.setState({ errorPassword: true });
                this.setState({ btnloader: false });
            }else if (data == 'not_active') {
              this.setState({ notActivePassword: true });
              this.setState({ btnloader: false });
            }else if(data == 'not_verified'){
              this.setState({ notVerified: true });
              this.setState({ btnloader: false });
            } else {
              if(data.typedata == 'agent'){
             
                this.setState({ customerDetails: data });

                let Verified = '';
                if (data.verified == 1) {
                    Verified = true;
                }

                const dataSearch = {
                    first_name: data.first_name,
                    last_name: data.last_name,
                    email: data.email,
                    country_code: data.country_code,
                    verified: Verified,
                    uid: data.id,
                    agent_id: data.id,
                }

                let JsonData = JSON.stringify(dataSearch);

                localStorage.setItem('userDetails', JsonData);
              
               // window.location.reload(true);
               var base_url = window.location.origin;
               window.location.href = base_url+"/home";
               this.setState({ btnloader: false });
              // history.push("/home");
              // return <Redirect to='/home'  />
            }else if(data.typedata == 'user'){

                this.setState({ customerDetails: data });
    
                // let Verified = '';
                // if (data.verified == 1) {
                //     Verified = true;
                // }
    
                const dataSearch = {
                    first_name: data.user_first_name,
                    last_name: data.user_last_name,
                    email: data.user_email,
                    country_code: data.country_code,
                    uid: data.user_id,
                    agent_id: data.customer_agent_id,
                }
    
                let JsonData = JSON.stringify(dataSearch);
    
                localStorage.setItem('userDetails', JsonData);
              
               // window.location.reload(true);
               var base_url = window.location.origin;
               window.location.href = base_url+"/home";
               this.setState({ btnloader: false });
    
    
            }
          //  }else if(data.typedata == 'user'){

          //   this.setState({ customerDetails: data });

          //   // let Verified = '';
          //   // if (data.verified == 1) {
          //   //     Verified = true;
          //   // }

          //   const dataSearch = {
          //       first_name: data.user_first_name,
          //       last_name: data.user_last_name,
          //       email: data.user_email,
          //       country_code: data.country_code,
          //       uid: data.user_id,
          //       agent_id: data.customer_agent_id,
          //   }

          //   let JsonData = JSON.stringify(dataSearch);

          //   localStorage.setItem('userDetails', JsonData);
          
          //  // window.location.reload(true);
          //  var base_url = window.location.origin;
          //  window.location.href = base_url+"/home";
          //  this.setState({ btnloader: false });


          //  }
            }
        },
        (error) => {

        });
}
render() {
  return (
<>
<div id="login">
<aside id="agentlogin" style={{ width: '25%'}}>
    <figure> <a href="/"><img src="images/logo/seyLogo.png" alt="Holiday Seychelles" class="logo_sticky" /></a> </figure>
      <form class="form-horizontal" action="" method="post">
                {this.state.errorPassword && (
                 // <p className="error"> Email or Password is not correct !</p>
                 <div class="alert alert-danger" role="alert">
                   Your email or password is incorrect Please try again
                </div>
                )}
                {this.state.notActivePassword && (
                 // <p className="error"> Your Account is not verified !</p>
                  <div class="alert alert-danger" role="alert">
                   Your Account is not activated by System Admin!
                </div>
                  
                )}
                {this.state.notVerified && (
                 // <p className="error"> Your Account is not verified !</p>
                  <div class="alert alert-danger" role="alert">
                    You have not yet verified with your email!
                </div>
                  
                )}
      <div class="form-group" style={{marginBottom: '1rem'}}>
        <label>E mail</label>
        <input type="email" class="form-control"
                  placeholder="Email"
                  value={
                    this.state.LoginEmail
                  }
                  onChange={this.ChangeLoginEmail}/>
        <i class="icon_mail_alt"></i> 
        <span>  </span>
    </div>
      <div class="form-group" style={{marginBottom: '1rem'}}>
        <label>Password</label>
        <input class="form-control"  type="password"
                  placeholder="Password"
                  value={this.state.LoginPassword}
                  onChange={this.ChangeLoginPassword}/>
                <i class="icon_lock_alt"></i> 
        <span>  </span></div>
      <div class="clearfix add_bottom_30">
        <div class="checkboxes float-left">
        </div>
        <div class="float-right mt-1"><Link to="/agentforgotpass">Forgot Password?</Link></div>
      </div>
       {/* <button type="submit" class="btn_1 rounded full-width">Login</button> */}
       <button class="btn_1 rounded full-width" onClick={this.LoginConfirm}>Login &nbsp; {this.state.btnloader === true ? (<Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          visually-hidden="true"
        />) : ""} </button>
      <div class="text-center add_top_10"><strong><Link to='/agentsignup'>SignUp </Link></strong></div>
    </form>
  </aside>
  </div> 
    
    
  </>
        );
    }
}
export default AgentLogin;
